import { ShieldCheck, Award, GraduationCap, FileCheck2, Scale } from "lucide-react";
import { useTranslation } from "react-i18next";

// Ärliga trust-signaler — inga påhittade logotyper eller partnerskap.
const items = [
  { icon: Scale, key: "aTrust.law" },
  { icon: FileCheck2, key: "aTrust.updated" },
  { icon: GraduationCap, key: "aTrust.used" },
  { icon: ShieldCheck, key: "aTrust.payment" },
  { icon: Award, key: "aTrust.passRate" },
];

export function TrustBadges({ className = "" }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <section className={`mx-auto max-w-5xl ${className}`} aria-label={t("aTrust.aria")}>
      <p className="text-center text-xs font-medium uppercase tracking-wider text-muted-foreground">
        {t("aTrust.heading")}
      </p>
      <div className="mt-5 flex flex-wrap items-center justify-center gap-x-8 gap-y-4">
        {items.map(({ icon: Icon, key }) => (
          <div key={key} className="inline-flex items-center gap-2 text-sm text-muted-foreground">
            <Icon className="h-4 w-4 text-primary shrink-0" />
            <span>{t(key)}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
